module.exports = __webpack_public_path__ + "static/media/p6_0.551387b4.png";